/*
 * @Descripttion: hqx
 * @version: 1.0.0
 * @Author: zxx
 * @Date: 2023-07-26 16:59:03
 * @LastEditTime: 2023-07-26 17:47:50
 */
import { TyphoonSelect, TyphoonTimeline } from '@lethe/components'
import '@lethe/components/es/index.css'
import Vue from 'vue'

Vue.use(TyphoonSelect)
  .use(TyphoonTimeline)
